
$(document).ready(function () {
  var getAllSwatchGrades = '';
  $('.order-free-swatch-popup-right .pdp-variant-list-head').each(function () {
    getAllSwatchGrades = getAllSwatchGrades + ',' + $(this).text().trim();
  });
  console.log('my get all swatch grades is ' + getAllSwatchGrades);
  $('.grade-swatch').each(function () {
    var grade = $(this).data('grade');
    if (getAllSwatchGrades.indexOf(grade) === -1) {
      $(this).hide();
    }
  });
  const svgMarkup = `
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style="vertical-align: middle; margin-right: 8px;">
      <path d="M20.1253 6.9375H18.5625V3.75C18.5625 3.60082 18.5032 3.45774 18.3977 3.35225C18.2923 3.24676 18.1492 3.1875 18 3.1875H6C5.85082 3.1875 5.70774 3.24676 5.60225 3.35225C5.49676 3.45774 5.4375 3.60082 5.4375 3.75V6.9375H3.87469C2.66906 6.9375 1.6875 7.86281 1.6875 9V16.5C1.6875 16.6492 1.74676 16.7923 1.85225 16.8977C1.95774 17.0032 2.10082 17.0625 2.25 17.0625H5.4375V20.25C5.4375 20.3992 5.49676 20.5423 5.60225 20.6477C5.70774 20.7532 5.85082 20.8125 6 20.8125H18C18.1492 20.8125 18.2923 20.7532 18.3977 20.6477C18.5032 20.5423 18.5625 20.3992 18.5625 20.25V17.0625H21.75C21.8992 17.0625 22.0423 17.0032 22.1477 16.8977C22.2532 16.7923 22.3125 16.6492 22.3125 16.5V9C22.3125 7.86281 21.3309 6.9375 20.1253 6.9375ZM6.5625 4.3125H17.4375V6.9375H6.5625V4.3125ZM17.4375 19.6875H6.5625V14.8125H17.4375V19.6875ZM21.1875 15.9375H18.5625V14.25C18.5625 14.1008 18.5032 13.9577 18.3977 13.8523C18.2923 13.7468 18.1492 13.6875 18 13.6875H6C5.85082 13.6875 5.70774 13.7468 5.60225 13.8523C5.49676 13.9577 5.4375 14.1008 5.4375 14.25V15.9375H2.8125V9C2.8125 8.48344 3.28875 8.0625 3.87469 8.0625H20.1253C20.7113 8.0625 21.1875 8.48344 21.1875 9V15.9375ZM18.5625 10.875C18.5625 11.0604 18.5075 11.2417 18.4045 11.3958C18.3015 11.55 18.1551 11.6702 17.9838 11.7411C17.8125 11.8121 17.624 11.8307 17.4421 11.7945C17.2602 11.7583 17.0932 11.669 16.9621 11.5379C16.831 11.4068 16.7417 11.2398 16.7055 11.0579C16.6693 10.876 16.6879 10.6875 16.7589 10.5162C16.8298 10.3449 16.95 10.1985 17.1042 10.0955C17.2583 9.99248 17.4396 9.9375 17.625 9.9375C17.8736 9.9375 18.1121 10.0363 18.2879 10.2121C18.4637 10.3879 18.5625 10.6264 18.5625 10.875Z" fill="black"></path>
    </svg>
  `;

  const interval = setInterval(() => {
    const btn = document.getElementById('myBtn-litpdf');
    if (btn && !btn.querySelector('svg')) {
      // Clear once the element is found
      clearInterval(interval);

      // Add icon + text
      btn.innerHTML = svgMarkup + 'Print as PDF';
    }
  }, 100);
  const modal = document.getElementById('myModal-litpdf');
  const modalContent = modal.querySelector('.modal-content-litpdf');

  modal.addEventListener('click', function (e) {
    // If the click target is the modal itself and NOT a child of modal-content
    if (e.target === modal) {
      modal.removeAttribute('style'); // Remove inline style (hides the modal)
    }
  });
  $('body').on('click', '.dekstech-custom-select .options-selection__option-value', function () {
    var value = $(this).find('input').attr('value');
    console.log('my clicked value is ' + value);
    $('.dekstech-theme-options input').each(function () {
      var inputVal = $(this).attr('value');
      console.log('my input value is ' + inputVal);
      if (value === inputVal) {
        console.log('we match and trying to click');
        $(this).parent().trigger('click');
      }
    });
  });


  window.ChatNow = function () {
    let tries = 0;

    function openWhenReady() {
      if (typeof Chatra === 'function') {
        Chatra('openChat', true);
      } else if (tries < 10) {
        tries++;
        setTimeout(openWhenReady, 300); // Retry every 300ms
      } else {
        console.warn('Chatra still not loaded after 10 tries.');
      }
    }

    openWhenReady();
  };

  function updatePlusBtnText() {
    $('.pdp-sixtin-plus-var-li').each(function () {
      const totalSwatches = $(this).text().replace('+', '');
      const visibleSwatches = $(this).siblings(':not(.pdp-sixtin-plus-var-li)').length;
      console.log("totalSwatches, visibleSwatches", totalSwatches, visibleSwatches);
      // Calculate remaining swatches

      // For mobile, subtract 2 more from the count
      const isMobile = window.innerWidth <= 767;
      if (isMobile) {
        let remainingSwatches = parseInt(totalSwatches) + 2;
        const $button = $('.pdp-sixtin-plus-var');

        $button.text('+' + remainingSwatches);
      }

      // Update the text

    });
  }

  // Run on page load and window resize
  updatePlusBtnText();

  // when a swatch is clicked, we highlight it
  $('.pdp-variant-list li').click(function () {
    // Inside your click function...

const $overlay = $('#rendering-overlay');
const $overlayText = $('#overlay-text');
const $spinner = $('.spinner');
const $closeBtn = $('#close-overlay');

// At the top of your click function, grab the button references
const $mobileBtn = $('#show-image-mobile');

// 1. Reset button state immediately on every swatch click
$mobileBtn.hide().removeClass('is-ready is-loading not-available');
    if ($(this).hasClass('pdp-sixtin-plus-var-li')) {
      // Just show the popup and exit
      $('body').addClass('order-swatch-popup-body');
      return;
    }

    $(this).siblings().removeClass('active');
    // Make this list item active within its own section
    $('.order-swatch-popup-right .pdp-variant-list li').each(function () {
      if (!$(this).hasClass('finish-details') && !$(this).hasClass('trim-details')) {
        $(this).removeClass('active');
      }


    });

    $(this).addClass('active');

    // Get the image inside this list item
    var $img = $(this).find('.swatch-before-arrow img');

    // Get leather name data
    var swatchValue = $img.data('leather-name');

    // We no longer sync with popup swatches to keep them separate
    // $('.order-swatch-popup-right li').removeClass('active');
    // $('.order-swatch-popup-right li[data-leather-name="' + swatchValue + '"]').addClass('active');

    var Grade = $img.data('leather-grade').trim();
    var LeatherName = $img.data('leather-name').trim();
    var hexidecimal = $img.data('hexidecimal');

if (hexidecimal) {
    hexidecimal = hexidecimal.replace('#', '');
}
//    console.log('my hexadecimal is', hexidecimal);
    /* dekstech 04/03/26 - added additional s to urls to keep functionality off for now */
    let cloudinaryUrls = $('#cloudnary-urls').data('cloudinary-urls');
    // console.log('my cloudinary urls are', cloudinaryUrls[0]);


    if (hexidecimal && cloudinaryUrls && cloudinaryUrls.length > 0) {
      // Reset overlay state every click
$overlayText.text('Rendering Image...');
$spinner.show();
$closeBtn.hide();
      // if we actually have cloudinary URLs and a hex, we should show a 'rendering image overlay'
      // 1. IMMEDIATELY show the overlay
      // 1. Force the overlay to show immediately
    const $overlay = $('#rendering-overlay');
    $('#rendering-overlay').stop(true, true).fadeIn(100);
    $mobileBtn.css('display','flex').addClass('is-loading').find('span').text('Rendering Image...');
      // Process all URLs and replace {HEX} with the actual hexadecimal value
      const processedUrls = cloudinaryUrls.map(url => {
        let decodedUrl = decodeURIComponent(url);
        return decodedUrl.replace(/{HEX}/gi, hexidecimal);
      });

     // console.log('Generated URLs:', processedUrls);

      // Load the first image for the main gallery
      const mainUrl = processedUrls[0];
      const img = new Image();

      // Helper function to adjust gallery height
      const adjustGalleryHeight = () => {
        const $viewer = $('[data-gallery-viewer]');
        const $selectedFigure = $('.product-gallery--media[data-gallery-selected="true"]');

        if ($selectedFigure.length && $viewer.length) {
          // Wait a tick for DOM to update
          setTimeout(() => {
            const figureHeight = $selectedFigure[0].getBoundingClientRect().height;
            if (figureHeight > 0) {
              $viewer[0].style.height = `${figureHeight}px`;

              // If Flickity is active, trigger resize
              const flickityInstance = $viewer.data('flickity');
              if (flickityInstance && typeof flickityInstance.resize === 'function') {
                flickityInstance.resize();
              }
            }
          }, 50);
        }
      };

      img.onload = () => {
        // Update the main gallery image - find the currently selected figure
        const $selectedFigure = $('.product-gallery--media[data-gallery-selected="true"]');
        const $mainImage = $selectedFigure.find('.product-gallery--loaded-image');

        // IMPORTANT: Store original image data before modifying
        if (!$mainImage.data('original-src')) {
          $mainImage.data('original-src', $mainImage.attr('src'));
          $mainImage.data('original-zoom', $mainImage.attr('data-zoom'));
        }

        // Store original dimensions and styles to maintain
        const originalWidth = $mainImage.css('width');
        const originalHeight = $mainImage.css('height');
        const originalMaxWidth = $mainImage.css('max-width');
        const originalMaxHeight = $mainImage.css('max-height');

        // Update all instances of the loaded image (there might be multiple)
        if ($mainImage.length > 0) {
          $mainImage
            .attr('src', mainUrl)
            .removeAttr('srcset')
            .removeAttr('sizes')
            .attr('data-zoom', mainUrl)
            .css({
              'width': originalWidth,
              'height': originalHeight,
              'max-width': originalMaxWidth,
              'max-height': originalMaxHeight,
              'object-fit': 'contain'
            });

          // Adjust height after image update
          adjustGalleryHeight();
        } else {
          // Fallback to class selector if no selected figure
          const $fallbackImage = $('.product-gallery--loaded-image').first();
          if (!$fallbackImage.data('original-src')) {
            $fallbackImage.data('original-src', $fallbackImage.attr('src'));
            $fallbackImage.data('original-zoom', $fallbackImage.attr('data-zoom'));
          }
          $fallbackImage
            .attr('src', mainUrl)
            .removeAttr('srcset')
            .removeAttr('sizes')
            .attr('data-zoom', mainUrl)
            .css('object-fit', 'contain');
          adjustGalleryHeight();
        }

        // Update background image if it exists
        const $backgroundDiv = $selectedFigure.find('.product-gallery--image-background');
        if ($backgroundDiv.length > 0) {
          // Store original background
          if (!$backgroundDiv.data('original-background')) {
            $backgroundDiv.data('original-background', $backgroundDiv.css('background-image'));
          }
          $backgroundDiv.css('background-image', `url(${mainUrl})`);
        }

        // Add click handlers to ORIGINAL thumbnails to restore original images
        $('.product-gallery--media-thumbnail').not('.custom-cloudinary-thumb').off('click.customColorRestore').on('click.customColorRestore', function () {
          console.log('Original thumbnail clicked - restoring original image');

          // Get the data-media attribute to find corresponding figure
          const mediaId = $(this).attr('data-media');
          const $targetFigure = $(`.product-gallery--media[data-media="${mediaId}"]`);
          const $targetImage = $targetFigure.find('.product-gallery--loaded-image');

          // Restore original image if it was stored
          if ($targetImage.length > 0 && $targetImage.data('original-src')) {
            $targetImage
              .attr('src', $targetImage.data('original-src'))
              .attr('data-zoom', $targetImage.data('original-zoom') || $targetImage.data('original-src'))
              .css({
                'object-fit': 'contain',
                'width': '100%',
                'height': '100%',
                'max-width': '100%',
                'max-height': '100%'
              });

            // Restore background if exists
            const $targetBackground = $targetFigure.find('.product-gallery--image-background');
            if ($targetBackground.length > 0 && $targetBackground.data('original-background')) {
              $targetBackground.css('background-image', $targetBackground.data('original-background'));
            }

            // Adjust height after restore
            adjustGalleryHeight();
          }

          // Deselect all custom thumbnails
          $('.custom-cloudinary-thumb').attr('data-gallery-selected', 'false');
        });

        // If there are additional images, add them as thumbnails
        if (processedUrls.length > 1) {
          const $thumbnailContainer = $('.gallery-navigation--scroller');

          // Remove any previously added custom thumbnails (optional, to prevent duplicates)
          $thumbnailContainer.find('.custom-cloudinary-thumb').remove();

          // Prepend thumbnails for each additional image
          processedUrls.forEach((url, index) => {
            // Create thumbnail button
            const $thumbnail = $(`
              <button
                class="product-gallery--media-thumbnail product-gallery--image-thumbnail custom-cloudinary-thumb"
                type="button"
                tabindex="0"
                aria-label="Custom color thumbnail ${index + 1}"
                data-gallery-thumbnail
                data-gallery-index="custom-${index}"
                data-gallery-selected="${index === 0 ? 'true' : 'false'}"
                data-cloudinary-url="${url}"
              >
                <span class="product-gallery--media-thumbnail-img-wrapper" tabindex="-1">
                  <img
                    class="product-gallery--media-thumbnail-img"
                    src="${url}"
                    alt="Custom color thumbnail ${index + 1}"
                    loading="lazy"
                    style="object-fit: cover;"
                  />
                </span>
              </button>
            `);

            // Add click handler to switch main image
            $thumbnail.on('click', function (e) {
              e.preventDefault();
              e.stopPropagation();

              const clickedUrl = $(this).data('cloudinary-url');
              console.log('Custom thumbnail clicked, URL:', clickedUrl);

              // Find the currently selected gallery figure
              const $selectedFigure = $('.product-gallery--media[data-gallery-selected="true"]');
              const $mainImage = $selectedFigure.find('.product-gallery--loaded-image');

              // Create a new image to ensure it loads before updating
              const updateImg = new Image();
              updateImg.onload = () => {
                // Update main image
                if ($mainImage.length > 0) {
                  $mainImage
                    .attr('src', clickedUrl)
                    .removeAttr('srcset')
                    .removeAttr('sizes')
                    .attr('data-zoom', clickedUrl)
                    .css({
                      'object-fit': 'contain',
                      'width': '100%',
                      'height': '100%',
                      'max-width': '100%',
                      'max-height': '100%'
                    });
                } else {
                  // Fallback
                  $('.product-gallery--loaded-image').each(function () {
                    $(this)
                      .attr('src', clickedUrl)
                      .removeAttr('srcset')
                      .removeAttr('sizes')
                      .attr('data-zoom', clickedUrl)
                      .css({
                        'object-fit': 'contain',
                        'width': '100%',
                        'height': '100%'
                      });
                  });
                }

                // Update selected state on ALL thumbnails
                $('.product-gallery--media-thumbnail').attr('data-gallery-selected', 'false');
                $(this).attr('data-gallery-selected', 'true');

                // Also update the background image if it exists
                const $backgroundDiv = $selectedFigure.find('.product-gallery--image-background');
                if ($backgroundDiv.length > 0) {
                  $backgroundDiv.css('background-image', `url(${clickedUrl})`);
                }

                // CRITICAL: Adjust gallery height after image loads
                adjustGalleryHeight();
              };
              updateImg.src = clickedUrl; // Start loading
            });

            // Prepend to thumbnail container
            $thumbnailContainer.prepend($thumbnail);
          });
        }
      };
const $selectedFigure = $('.product-gallery--media[data-gallery-selected="true"]');
    const $mainImage = $selectedFigure.find('.product-gallery--loaded-image');

   // 2. Create the "Watcher"
    const waitForImage = new Promise((resolve, reject) => {
        // Safety timeout so user isn't stuck
        const timeout = setTimeout(() => {
            console.warn("Image load timed out, showing anyway.");
            resolve(); 
        }, 8000);

        // Define what "Success" looks like
        const onSuccess = () => {
            clearTimeout(timeout);
            resolve();
        };

        // Attach listeners BEFORE changing the source
        $mainImage.off('load error').one('load', onSuccess).one('error', (e) => {
            clearTimeout(timeout);
            // Only reject if it's a real failure, not a cache quirk
            if (!$mainImage[0].complete) reject(e);
            else resolve();
        });

        // 3. TRIGGER THE LOAD
        $mainImage
            .removeAttr('srcset') 
            .removeAttr('sizes')
            .attr('src', mainUrl)
            .attr('data-zoom', mainUrl)
            .attr('srcset',mainUrl);
        $('.pswp__img').attr('src',mainUrl);

        // 4. THE CACHE CHECK (The fix for your specific error)
        // If the image is already in cache, 'load' might not fire.
        if ($mainImage[0].complete && $mainImage[0].naturalWidth > 0) {
            onSuccess();
        }

        // Handle Background Div
        const $backgroundDiv = $selectedFigure.find('.product-gallery--image-background');
        if ($backgroundDiv.length > 0) {
            $backgroundDiv.css('background-image', `url(${mainUrl})`);
        }
    });

        // Handle Background Div if applicable
        const $backgroundDiv = $selectedFigure.find('.product-gallery--image-background');
        if ($backgroundDiv.length > 0) {
            $backgroundDiv.css('background-image', `url(${mainUrl})`);
        }

    // 4. Execution: Only hide overlay when the Promise resolves
    waitForImage.then(() => {
        // Extra "Paint" buffer: 200ms ensures the browser has rendered the pixels
        setTimeout(() => {
            $overlay.fadeOut(500);
// 3. Set to READY state
            $mobileBtn.show();
            $mobileBtn.removeClass('is-loading').addClass('is-ready');
            $mobileBtn.find('span').text('Show Preview Image');

            // Set up the scroll action
            $mobileBtn.off('click').on('click', function() {
                $("html, body").animate({ scrollTop: 0 }, 600);
            });

            adjustGalleryHeight();
        }, 200);
    }).catch(() => {
        $overlay.hide();
        $mobileBtn.hide();
        console.error("Cloudinary image failed to load.");
    });
    }
else {
  /* do nothing because no cloudinary URLs
    // FALLBACK: Hexadecimal is missing or URLs are empty
    $overlay.stop(true, true).fadeIn(200);
    $overlayText.text('Image preview not available for this selection.');
    $spinner.hide();
    // 4. Set to NOT AVAILABLE state
    $mobileBtn.addClass('not-available').html('Preview not available for this selection').show();
    
    // Optional: Hide it after 4 seconds automatically
    setTimeout(() => { $mobileBtn.fadeOut(); }, 4000);
    $closeBtn.show().off('click').on('click', function() {
        $overlay.fadeOut(200);
    });

    // Auto-hide after 3 seconds so the user isn't stuck
    setTimeout(() => {
        $overlay.fadeOut(500);
    }, 3000);
    */
}

    // Update options selection
    if (Grade && Grade.trim() !== 'No Grade') {
      var inPopup = $(this).closest('.order-swatch-popup-section').length > 0;
      var foundGrade = false;
      // In the popup only Grade 1 is cart-eligible (client rule: sectionals show price for Grade 1 only).
      // Skip the span search entirely for Grade 2+ in the popup so a live DOM span can't override this.
      if (!inPopup || Grade === 'Grade 1') {
        $('.options-selection__option-values span').each(function () {
          if ($(this).text().trim() === Grade) {
            $(this).trigger('click');
            $('#selected-leather').val(LeatherName);
            $('#selected-leather').attr('value', LeatherName);
            foundGrade = true;
          }
        });
      }
      // Fallback: span may be absent from DOM (options-selection web component removes it for
      // inaccessible variants). If the click is from the popup and Grade 1, treat as found.
      if (!foundGrade && inPopup && !window.dekstech_isAlwaysCallForPricing && Grade === 'Grade 1') {
        $('#selected-leather').val(LeatherName);
        $('#selected-leather').attr('value', LeatherName);
        foundGrade = true;
      }
      if (foundGrade === false) {
        // we need to change all the buttons because the pricing will not be shown on website, they need to call
        $('.save-swatches-btn').text('Call For Pricing');
        $('#popup-footer-price').hide();
        $('.call_price').removeAttr('style');
        if (!window.dekstech_isSectional) {
          $('.product-form--atc-button').find('.atc-button--text').text('Call For Pricing');
        }
        $('.product-pricing').find('.product__price').addClass('hide-price');
      }
      else {
        $('.save-swatches-btn').text(window.dekstech_isSectional ? 'Call to Order' : 'Order Now');
        $('.call_price').hide();
        $('#popup-footer-price').show();
        if (!window.dekstech_isSectional) {
          $('.product-form--atc-button').find('.atc-button--text').text('Add to Cart');
        }
        $('.product-pricing').find('.product__price').removeClass('hide-price')
      }
    }
    var product_tags = $('#product-tags').attr('value')

    // Handle special cases
    if ($img.hasClass('finish')) {
      if (product_tags.indexOf('no-wood') > -1) {

      }
      else {
        $('#wood-finish').val(LeatherName);
        $('#wood-finish').attr('value', LeatherName);
        $('#finish-name-wrapper span').text(LeatherName);
      }
    }
    else if ($img.hasClass('trim')) {


      if (product_tags.indexOf('no-nail') > -1) {

      }

      else {
        $('#nail-trim').val(LeatherName);
        $('#nail-trim').attr('value', LeatherName);
        $('#trim-name-wrapper span').text(LeatherName);
      }
    }
    else {
      $('#leather-popup-name').text(LeatherName);
      $('#leather-name-wrapper span').text(LeatherName);
    }
  });

  // When a swatch is clicked in the popup
  $('.order-swatch-popup-right li').click(function () {

    // Make this popup swatch active
    $(this).siblings().removeClass('active');
    $(this).addClass('active');
    // ✅ Only apply on mobile
    if (window.innerWidth <= 768) {
      const popup = $(this).find('.pdp-variant-popup-section');
      if (popup.length) {
        console.log('found and trying to replace');

        const img = popup.find('.pdp-variant-popup-left').html();
        const textSection = popup.find('.pdp-variant-popup-right').clone();

        // ✅ Move .protected-desc to top
        const protectedDesc = textSection.find('.protected-desc');
        if (protectedDesc.length) {
          protectedDesc.prependTo(textSection); // moves it to be the first child
        }

        const updatedText = textSection.html();

        $('.image-holder, .content-holder').stop(true, true).fadeOut(150, function () {
          if ($(this).hasClass('image-holder')) {
            $(this).html(img);
          } else {
            $(this).html(updatedText);
          }
        }).fadeIn(150);
      } else {
        console.log('not found');
      }
    }
    // lets get the active swatch
    if ($(this).hasClass('free-swatch')) {
      return
    }
    else {

      var selectedSwatch = $('.order-swatch-popup-section').find('.pdp-variant-list li.active');
      var activeImg = $('.order-swatch-popup-section').find('.pdp-variant-list li.active').find('img').attr('src');
      var popupHTML = selectedSwatch.find('.pdp-variant-popup-section').html();
      $('.variant-details.active').removeClass('active');
      var foundSwatch = 0;
      $('.variant-details').each(function () {
        var leather = $(this).data('leather-name');
        if (selectedSwatch.data('leather-name') === leather) {
          $(this).addClass('active');
          foundSwatch = 1;
        }
      });
      if (foundSwatch === 0) {
        $('.variant-details').eq(0).addClass('active');
      }
      console.log('setting attributes like '+ selectedSwatch.data('hexidecimal') + ' and leather name of ' +  selectedSwatch.data('leather-name'));
      $('.variant-details.active').find('img').attr('src', activeImg);
      $('.variant-details.active').find('img').attr('data-leather-name', selectedSwatch.find('img').data('leather-name'));
      $('.variant-details.active').find('img').attr('data-hexidecimal', selectedSwatch.find('img').data('hexidecimal'));
      $('.variant-details.active').find('.pdp-variant-popup-section').html(popupHTML);
      $('#leather-name-wrapper').find('span').text(selectedSwatch.data('leather-name'));
      console.log($('#leather-popup-name').length);
      $('#leather-popup-name').empty().text(selectedSwatch.data('leather-name'));
    }
  });


  $('.american-heirloom-popup-part').on('click', function (e) {
    // Remove active class from siblings to ensure only one is active at a time
    $(this).siblings('.american-heirloom-popup-part').removeClass('active');
    $(this).addClass('active');
    $('#cushion-option').val($(this).data('cushion-option'));
  });
  $('body').on('click', '.product-form--atc-button', function (e) {
    // Let our tel: Call to Order link dial without interference
    if ($(this).is('a[href^="tel:"]')) {
      return;
    }
    e.preventDefault(); // Stop form submission early
    e.stopImmediatePropagation();
    const btnText = $(this).find('.atc-button--text').text().trim();
    const form = $(this).closest('form');
    const formDataArray = form.serializeArray(); // Used by AddToCartFlyout

    // Handle "Call For Pricing"
    if (btnText === 'Call For Pricing' || btnText === 'Calling For Pricing') {
      const link = document.querySelector('.call_price a');
      if (link) link.click();
      return;
    }

    // Cushion check
    const cushionVisible = $('.cushion-pdp-desc').css('display') === 'block';
    const cushionSelected = $('.american-heirloom-popup-part.active').length > 0;

    if (cushionVisible && !cushionSelected) {
      alert('You must pick a cushion before adding this product to cart');
      $('body').addClass('american-heirloom-popup-body');
      return;
    }

    // ✅ All validation passed — now instantiate AddToCartFlyout
    new AddToCartFlyout(formDataArray, {
      atcButton: this,
      settings: {
        moneyFormat: Shopify.money_format,
        cartRedirection: false // Or true if needed
      }
    });
  });

$('body').on('click','#show-image-mobile',function() {
$('.order-swatch-popup-close').trigger('click');
$("html, body").animate({ scrollTop: 0 }, "slow");
});

});